import {
  Trans,
  useTranslation,
  useValidationCheckbox,
} from '@zurich/common/hooks';
import { Stack, Typography } from '@zurich/ui/atoms';
import { Checkbox, Notice } from '@zurich/ui/legacy/components';
import {
  dryAndCleanCarSelector,
  dryAndCleanValidationSelector,
  enoughSpaceSelector,
  enoughSpaceValidationSelector,
  sunnyAndDryWeatherSelector,
  sunnyAndDryWeatherValidationSelector,
  timeBeforeSelector,
  timeBeforeValidationSelector,
} from '~/state';
import { StepLayout } from './StepLayout';

export function PreCheck() {
  const { t } = useTranslation();

  const dryAndCleanProps = useValidationCheckbox({
    atom: dryAndCleanCarSelector,
    validationSelector: dryAndCleanValidationSelector,
    fieldName: 'dryAndClean',
    i18nPrefix: 'vsga:checkboxes.',
    nullable: true,
  });

  const sunnyAndDryWeatherProps = useValidationCheckbox({
    atom: sunnyAndDryWeatherSelector,
    validationSelector: sunnyAndDryWeatherValidationSelector,
    fieldName: 'sunnyAndDryWeather',
    i18nPrefix: 'vsga:checkboxes.',
    nullable: true,
  });

  const enoughSpaceProps = useValidationCheckbox({
    atom: enoughSpaceSelector,
    validationSelector: enoughSpaceValidationSelector,
    fieldName: 'enoughSpace',
    i18nPrefix: 'vsga:checkboxes.',
    nullable: true,
  });

  const timeBeforeProps = useValidationCheckbox({
    atom: timeBeforeSelector,
    validationSelector: timeBeforeValidationSelector,
    fieldName: 'timeBefore',
    i18nPrefix: 'vsga:checkboxes.',
    nullable: true,
  });

  return (
    <StepLayout stepName="preCheck">
      <Typography variant="body1 medium" color="darkBlue">
        {t('vsga:general.subtitleHowItWorks')}
      </Typography>
      <Typography variant="body2 light" color="darkBlue">
        <Trans
          i18nKey="vsga:preCheck.body"
          components={{
            br: <br />,
          }}
        />
      </Typography>
      <Stack rowGap={3}>
        <Checkbox
          {...dryAndCleanProps}
          label={
            <Typography variant="body2 light" color="darkBlue">
              {t('vsga:checkboxes.dryAndClean.label')}
            </Typography>
          }
        />
        <Checkbox
          {...sunnyAndDryWeatherProps}
          label={
            <Typography variant="body2 light" color="darkBlue">
              {t('vsga:checkboxes.sunnyAndDryWeather.label')}
            </Typography>
          }
        />
        <Checkbox
          {...enoughSpaceProps}
          label={
            <Typography variant="body2 light" color="darkBlue">
              {t('vsga:checkboxes.enoughSpace.label')}
            </Typography>
          }
        />
        <Checkbox
          {...timeBeforeProps}
          label={
            <Typography variant="body2 light" color="darkBlue">
              {t('vsga:checkboxes.timeBefore.label')}
            </Typography>
          }
        />
        <Notice type="neutral">{t('vsga:preCheck.tip')}</Notice>
      </Stack>
    </StepLayout>
  );
}
